import type { InlineItem } from 'components/form/types';
import type { PositionBreakdown } from './types';
import type { Position } from 'modules/campaign/row';
import type { PlanMutations } from 'modules/campaign/plan/state/mutate';
import { useEffect, useState } from 'react';

type PositionsBreakdown = {
  positions: PositionBreakdown[];
  total: PositionBreakdown;
};

export function useBreakdown({
  positions,
  rowId,
  requestHandler,
}: {
  positions: InlineItem<Position>[] | undefined;
  rowId: number;
  requestHandler: PlanMutations['requestHandler'];
}): PositionsBreakdown | null {
  const [breakdown, setBreakdown] = useState<PositionsBreakdown | null>(null);

  useEffect(() => {
    const valid = positions?.every((v) => v.date_from && v.date_to);
    if (!valid) {
      setBreakdown(null);
      return;
    }
    let cancelled = false;
    requestHandler<PositionsBreakdown>({
      method: 'POST',
      url: `plan/rows/${rowId}/position_breakdown/`,
      body: { positions: positions?.map((p) => ({ ...p, quantity: p.quantity || '0' })) || [] },
    }).then((res) => {
      if (!cancelled) {
        setBreakdown(res);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [rowId, requestHandler, positions]);

  return breakdown;
}
